import * as React from 'react'
import { AccountSettingsService } from './settingsService'
import { NotificationsService } from './notificationsService'

export const AccountSettingsServiceContext = React.createContext(null as any as AccountSettingsService)
export const NotificationsServiceContext = React.createContext(null as any as NotificationsService)
